import axios from "axios";
import React, { Dispatch, SetStateAction, useRef, useState } from "react";
import Button from "../../components/Button";
import { useUser } from "../UserContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { faFileUpload } from "@fortawesome/free-solid-svg-icons";

const UploadReplays = ({
  laps,
  setUpdate,
  update,
}: {
  laps: number;
  setUpdate: Dispatch<SetStateAction<boolean>>;
  update: boolean;
}) => {
  const { t } = useTranslation();
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [show, setShow] = useState(true);

  const handleButtonClick = () => {
    fileInputRef.current?.click(); // dispara el input hidden
  };

  const handleFilesSelected = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = event.target.files;
    if (!files || token == null) return;

    const selectedFiles = Array.from(files);
    const rplFiles = selectedFiles.filter(
      (file) =>
        file.name.toLowerCase().endsWith(".rpl") ||
        file.name.toLowerCase().endsWith(".ini"),
    );

    const tooBig = rplFiles.some((file) => file.size > 15 * 1024 * 1024);
    if (tooBig) {
      toast.error(t("Each file must be less than 15MB") as string);
      return;
    }

    // Validación segura del token
    let extractedToken = token;
    try {
      const parsed = JSON.parse(token);
      if (parsed && parsed.token) extractedToken = parsed.token;
    } catch (e) {
      // Si no es un JSON válido, asumimos que el token ya es el string directo
    }

    const formData = new FormData();
    rplFiles.forEach((file) => {
      formData.append("replays", file);
    });

    formData.append("user", user);
    formData.append("token", extractedToken);
    console.log(user);
    console.log(extractedToken);

    rplFiles.forEach((f) => {
      console.log(f.name, f.size);
    });
    try {
      const { data } = await axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/uploadReplay`,
        formData,
      );

      toast.success(t("Replays uploaded succesfully") as string); // Nota: revisa si esto era un error o success en tu código original
      setUpdate(!update);
    } catch (error: any) {
      const errorMsg =
        error.response?.data?.message ||
        error.message ||
        "Error while uploading replays";
      toast.error(errorMsg);
    }
  };

  if (!show) return <></>;
  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept=".rpl,.ini"
        multiple
        style={{ display: "none" }}
        onChange={handleFilesSelected}
      />
      <Button
        onClick={handleButtonClick}
        text={t("Upload Replays")}
        icon={faFileUpload}
        iconPosition="left"
      />
    </>
  );
};

export default UploadReplays;
